export const API_URL = '';
export const API_ENDPOINT = '/api';

export const getAssetUrl = (path: string | undefined): string => {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  if (path.startsWith('/uploads')) return `${API_URL}${path}`;
  return `${API_URL}/uploads/documents/${path}`;
}; 